import type { Vec3, Vec4 } from "eutopia.ts";
import { createLayer, createLayerType, line } from "eutopia.ts";
import { $, type Properties, resolve } from "signlets";

import { positionEmpty } from "../position";
import { scaleOpacity } from "./color";

export type StemProps = {
  stems: Properties<Stem>[];
};

export type Stem = {
  position: Vec3;
  color: Vec4;
};

export const stem = createLayerType<StemProps>((context, { stems }) =>
  createLayer(
    context,
    line({
      vertices: $(() =>
        resolve(stems).map(({ position, color }) => {
          const [lon = 0, lat = 0, alt = 0] = resolve(position);
          const points = [
            [lon, lat, alt],
            [lon, lat, 0],
          ] as const;
          return points.map(position => ({
            position,
            color: scaleOpacity(
              resolve(color),
              !positionEmpty(resolve(position)) ? 1 : 0,
            ),
            width: 1,
            minWidthPixels: 3,
          }));
        }),
      ),
      pickable: false,
      outline: [0, 0, 0, 1],
    }),
  ),
);
